import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { finalize } from 'rxjs';
import { apiErrorFallback, extractApiErrorMessage } from '../../../../../core/http/extract-api-error-message';
import { Translation } from '../../../../../core/i18n/translation.service';
import { AssetChargesService } from '../../../../../core/services/asset-charges.service';
import { BenefitsDialogComponent } from '../../benefits/shared/dialogs/benefits-dialog/benefits-dialog.component';

/** Waives what is left of a charge; the reason is required. */
@Component({
  selector: 'app-waive-charge-dialog',
  standalone: true,
  imports: [TranslatePipe, ButtonModule, BenefitsDialogComponent],
  templateUrl: './waive-charge-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaiveChargeDialogComponent {
  private readonly charges = inject(AssetChargesService);
  private readonly translation = inject(Translation);

  readonly chargeId = input.required<string>();
  readonly waived = output<void>();
  readonly closed = output<void>();

  protected readonly reason = signal('');
  protected readonly saving = signal(false);
  protected readonly error = signal<string | null>(null);
  protected readonly valid = computed(() => !!this.reason().trim());

  protected confirm(): void {
    if (!this.valid() || this.saving()) return;
    this.saving.set(true);
    this.error.set(null);
    this.charges
      .waive(this.chargeId(), this.reason().trim())
      .pipe(finalize(() => this.saving.set(false)))
      .subscribe({
        next: () => this.waived.emit(),
        error: (err) => this.error.set(extractApiErrorMessage(err, apiErrorFallback(this.translation))),
      });
  }
}
